import classNames from 'classnames';
import {Button, ButtonProps} from 'antd';

import useCommon from '@utils/hooks/common';
import styles from './styles';
import {useEffect, useState} from 'react';
import {autorun, toJS} from 'mobx';
import TabBubble from '@components/game-room/TabBubble';
import {JoinedRoomProps} from 'poker-interfaces/game-room/game-room-interface';
import {TabBubbleUiInterface} from '@interface/index';
import {useRouter} from 'next/router';
import {isTelegramMiniApp} from '@components/layout';
import TelegramTabBubble from '@components/telegram/RoomStatusBar/TelegramTabBubble';

interface TabBubbleSectionProps {
  className?: string;
}

const TabBubbleSection = (props: TabBubbleSectionProps): JSX.Element[] => {
  const {classes, t, language, user, system} = useCommon({
    withTranslation: null,
    withStyles: styles,
    observers: ['user', 'language', 'system'],
  });
  const router = useRouter();
  const isDebug = router?.query?.isDebugView === 'true';

  const {className, children} = props;

  const [joinedRooms, setJoinedRooms] = useState<Array<JoinedRoomProps>>([]);
  const [bubbleContent, setButtonContent] = useState<TabBubbleUiInterface[]>([
    null,
    null,
    null,
    null,
  ]);

  useEffect(() => {
    autorun(() => {
      if (user?.joinedRooms?.length > 0) {
        console.log('user?.joinedRooms in TabBubbleSection', toJS(user?.joinedRooms));
        if (JSON.stringify(user?.joinedRooms) != JSON.stringify(joinedRooms)) {
          setJoinedRooms(user?.joinedRooms || []);
        }
      } else {
        setJoinedRooms([]);
      }

      if (JSON.stringify(system?.tabBubbleContent) != JSON.stringify(bubbleContent)) {
        setButtonContent(system?.tabBubbleContent.map(element => element));
      }
    });
  }, []);

  return joinedRooms?.map((room, index) => {
    return isTelegramMiniApp ? (
      <TelegramTabBubble
        onClick={() => {
          system?.setActiveTableIndex(index);
          system?.showGameOverlayWithoutPush();

          const query = {...router.query, currentRoom: room?.roomCode};

          router.replace(
            {
              pathname: '/telegram/game-list',
              query,
            },
            undefined,
            {shallow: true}
          );
        }}
        key={room?.roomCode}
        roomCode={room?.roomCode}
        bubbleData={bubbleContent[index]}
        index={index}
        isHighlighted={false}
      />
    ) : (
      <TabBubble
        onClick={() => {
          system?.setActiveTableIndex(index);
          system?.showGameOverlayWithoutPush();

          const query = {...router.query, currentRoom: room?.roomCode};

          router.replace(
            {
              pathname: '/home',
              query,
            },
            undefined,
            {shallow: true}
          );
        }}
        key={room?.roomCode}
        roomCode={room?.roomCode}
        bubbleData={bubbleContent[index]}
        index={index}
        isHighlighted={false}
      />
    );
  });
};

export default TabBubbleSection;
